<template>
    <div class="test-drive">
        <header>
            <img loading="lazy" src="../../assets/test-drive.webp" alt="banner img">
        </header>

        <div class="container">
            <h1>BOOK A TEST DRIVE</h1>

            <div class="block">
                <div v-if="theRes.length != 0" style="width: 100%;
                            border-radius: 10px;
                            padding: 1.2em;
                            text-transform: capitalize;
                            background: var(--noble-gold2);
                            border: 2px solid var(--noble-gold);
                            color: var(--tech-black);
                            display: flex;
                            align-items: center;
                            justify-content: space-between;">
                    {{ theRes}}

                    <button style="color: var(--tech-black);" @click="theRes=''">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                        </svg>
                    </button>
                 </div>

                <!-- personal details -->
                <div class="form">
                    <!-- username -->
                    <div>
                        <label class="title" for="username">Full Name</label>
                        <input v-model="name" id="username" type="text" placeholder="Full name">
                        <span class="errorTxt" v-if="errors.name.length>1">{{ errors.name }}</span>
                    </div>

                    <!-- email -->
                    <div>
                        <label class="title" for="email">Email</label>
                        <input v-model="email" type="email" placeholder="example@xyz.com">
                        <span class="errorTxt" v-if="errors.email.length>1">{{ errors.email }}</span>
                    </div>

                    <!-- phone -->
                    <div>
                        <label class="title" for="phone">Phone Number</label>
                        <input v-model="phone" type="text" placeholder="+218-9x-xxxxxxx">
                        <span class="errorTxt" v-if="errors.phone.length>1">{{ errors.phone }}</span>
                    </div>
                </div>

                <!-- location and date -->
                <div class="form">
                    <!-- city -->
                    <div>
                        <label class="title">Select a city for test drive</label>
                        
                        <div class="selected" @click="cityMenu= !cityMenu; carMenu=false">
                            {{ selectedCity }}
                            <svg :style="{transform: cityMenu ? 'rotate(180deg)':'rotate(0deg)'}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                            </svg>
                        </div>
                        <span class="errorTxt" v-if="errors.city.length>1">{{ errors.city }}</span>

                        <transition name="slide" mode="out-in" appear>
                            <div class="menu" v-if="cityMenu">
                                <span v-for="city in cities" :key="city.value" @click="selectedCity=city.value; cityMenu=false">{{ city.name }}</span>
                            </div>
                        </transition>
                    </div>

                    <!-- date -->
                    <div>
                        <label class="title">Date</label>
                        <date-picker format="YYYY-MM-DD"
                                    placeholder="Select date" 
                                    v-model="time1" 
                                    valueType="format" 
                                    input-class="my-date-input"></date-picker>
                        <span class="errorTxt" v-if="errors.time.length>1">{{ errors.time }}</span>
                        <!-- <div class="selected" @click="carMenu= !carMenu">
                            {{ selectedCar }}
                            <svg :style="{transform: carMenu ? 'rotate(180deg)':'rotate(0deg)'}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                            </svg>
                        </div>

                        <transition name="slide" mode="out-in" appear>
                            <div class="menu" v-if="carMenu">
                                <span v-for="car in cars" :key="car" @click="selectedCar=car; carMenu=false">{{ car }}</span>
                            </div>
                        </transition> -->
                    </div>
                </div>
                
                <!-- select a car -->
                <div class="form">
                    <div>
                        <label class="title">Select a Car</label>
                        
                        <div class="selected" @click="carMenu= !carMenu; cityMenu=false">
                            {{ selectedCar }}
                            <svg :style="{transform: carMenu ? 'rotate(180deg)':'rotate(0deg)'}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                            </svg>
                        </div>
                        <span class="errorTxt" v-if="errors.model.length>1">{{ errors.model }}</span>

                        <transition name="slide" mode="out-in" appear>
                            <div class="menu" v-if="carMenu">
                                <span v-for="car in cars" :key="car.name" @click="selectedCar=car.value; carMenu=false">{{ car.name }}</span>
                            </div>
                        </transition>
                    </div>
                </div>

            </div>

            <div class="cta">
                <div class="g-recaptcha" 
                    data-callback="onCaptchaVerified"
                    data-expired-callback="onCaptchaExpired"
                    data-sitekey="6LezQ64nAAAAABJ_1jDbMwjTWn07462potaAZN16"></div>

                <button class="square" @click="sendTestDrive()">submit</button>
            </div>
            <span style="color: red;" class="errorTxt" v-if="errors.captcha.length>1">{{ errors.captcha }}</span>
        </div>
        
    </div>
</template>

<script>
    /* global grecaptcha */
    import api from '@/apis';
import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
    export default {
        components: { DatePicker },
        data() {
            return {
                captchaToken: "", // store token here
                recaptchaWidgetId: null,
                name: "",
                phone: "",
                email: "",
                time1: null,
                selectedCity: "Select a city",
                selectedCar: "Select a model",

                theRes: "",
                errors: {
                    name: "",
                    phone: "",
                    email: "",
                    time: "",
                    city: "",
                    model: "",
                    captcha: ""
                },
                carMenu: false,
                cityMenu: false,
                cities: [],
                cars: []
            }
        },
        methods: {
            fetchCarsNames() {
                // /api/models/names
                api.get("/models/names")
                .then(res => {
                    this.cars = res.data.data;
                })
                .catch(err => {
                    console.log(err);
                    
                })
            },
            fetchCities() {
                api.get("/cities")
                .then(res => {
                    this.cities = res.data.data;
                })
                .catch(err => {
                    console.log(err);
                    
                })
            },
            validateForm() {
                // Reset errors first
                this.errors.name = "";
                this.errors.phone = "";
                this.errors.email = "";
                this.errors.model = "";
                this.errors.city = "";
                this.errors.time = "";

                let isValid = true;

                // ---------- NAME ----------
                if (!this.name.trim()) {
                    this.errors.name = "Name is required";
                    isValid = false;
                } else if (this.name.length < 3) {
                    this.errors.name = "Name must be at least 3 characters";
                    isValid = false;
                } else if (this.name.length > 255) {
                    this.errors.name = "Name cannot exceed 255 characters";
                    isValid = false;
                }

                // ---------- PHONE ----------
                const phoneRegex = /^[0-9]{9,15}$/;
                const phoneClean = this.phone.replace(/^\+/, "");
                if (!phoneClean) {
                    this.errors.phone = "Phone is required";
                    isValid = false;
                } else if (!phoneRegex.test(phoneClean)) {
                    this.errors.phone = "Phone must be 9–15 digits";
                    isValid = false;
                }

                // ---------- EMAIL ----------
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
                if (!this.email.trim()) {
                    this.errors.email = "Email is required";
                    isValid = false;
                } else if (this.email.length < 6) {
                    this.errors.email = "Email must be at least 6 characters";
                    isValid = false;
                } else if (this.email.length > 255) {
                    this.errors.email = "Email cannot exceed 255 characters";
                    isValid = false;
                } else if (!emailRegex.test(this.email)) {
                    this.errors.email = "Invalid email format";
                    isValid = false;
                }

                // ---------- MODEL ----------
                const modelRegex = /^[A-Za-z0-9 _-]{2,100}$/;
                if (!this.selectedCar || this.selectedCar === "Select a model") {
                    this.errors.model = "Model is required";
                    isValid = false;
                } else if (!modelRegex.test(this.model)) {
                    this.errors.model = "Model name is invalid";
                    isValid = false;
                }

                // ---------- CITY ----------
                const cityRegex = /^[A-Za-z\s]{2,100}$/;
                if (!this.selectedCity || this.selectedCity === "Select a city") {
                    this.errors.city = "City is required";
                    isValid = false;
                } else if (!cityRegex.test(this.city)) {
                    this.errors.city = "City name is invalid";
                    isValid = false;
                }

                // ---------- TIME / DATE ----------
                if (!this.time1) {
                    this.errors.time = "Date is required";
                    isValid = false;
                } else if (isNaN(Date.parse(this.time1))) {
                    // Check if the input is a valid date string
                    this.errors.time = "Invalid date format";
                    isValid = false;
                }
                
                return isValid;

            },
            sendTestDrive() {
                this.errors.captcha = "";

                if (!this.validateForm()) {return;}
                if (!this.captchaToken) {
                    this.errors.captcha = "Please complete the captcha.";
                    return;
                }

                api.post("/test_drive?locale=en", {
                    name: this.name,
                    email: this.email,
                    phone: this.phone.replace(/^\+/, ''),
                    model: this.selectedCar,
                    city: this.selectedCity,
                    date: this.time1,
                    'g-recaptcha-response': this.captchaToken // <-- this is critical
                })
                .then(res => {
                    this.theRes = res.data.message;
                    
                    this.name = "";
                    this.email = "";
                    this.phone = "";
                    this.selectedCar = "";
                    this.selectedCity = "";
                    this.time1 = null;
                })
                .catch(error => {
                    // console.log(error);
                    // ✅ Safely reset reCAPTCHA — only if available
                    if (typeof grecaptcha !== 'undefined' && grecaptcha.reset) {
                        // For auto-rendered reCAPTCHA with single widget, reset with no ID
                        grecaptcha.reset();
                        this.captchaToken = null;
                    }

                    // GLOBAL GUARD
                    if (!error.response ||
                        error.response.status !== 422 ||
                        !error.response.data ||
                        !error.response.data.errors) {
                        // not a validation error → ignore field mapping
                        return;
                    }

                    const backendErrors = error.response.data.errors;

                    // reset errors
                    this.errors.name = "";
                    this.errors.email = "";
                    this.errors.phone = "";
                    this.errors.model = "";

                    // map backend errors safely
                    Object.keys(this.errors).forEach(field => {
                        if (backendErrors[field]) {
                        this.errors[field] = backendErrors[field][0];
                        }
                    });
                });
            }
        },
        mounted() {
            this.fetchCities();
            this.fetchCarsNames();
            // reCAPTCHA calls these global functions
            window.onCaptchaVerified = (token) => {
                this.captchaToken = token;
                console.log("✅ CAPTCHA verified:", token);
            };

            window.onCaptchaExpired = () => {
                this.captchaToken = null;
                // console.log("⚠️ CAPTCHA expired");
            };
        },
        beforeDestroy() {
            // Clean up to avoid memory leaks
            delete window.onCaptchaVerified;
            delete window.onCaptchaExpired;
        },

    }
</script>